export const ACCESS_TOKEN_EXPIRY_THRESHOLD = 3;

export const RESEND_OTP_TIMEOUT_SEC = 60;

// Legacy JS cookie, still sent on login until it expires so trusted devices stay trusted
export const TRUST_TOKEN_COOKIE_KEY = 'trustToken';

export const enum RoleName {
    MerchantAdmin = 'MerchantAdmin',
    MerchantEmployee = 'MerchantEmployee',
    MerchantsAgent = 'MerchantsAgent',
    MerchantFinance = 'MerchantFinance',
    MerchantTech = 'MerchantTech',
    OnboardingE = 'OnboardingE',
    OnboardingO = 'OnboardingO'
};

export const enum Event {
    Redirect2FA = 'Event.Redirect2FA',
    GetUser = 'Event.GetUser'
};

